// extracted by mini-css-extract-plugin
export var contactModalWrapper = "modalsProvider-module--contactModalWrapper--1ifMU";
export var servicesModalWrapper = "modalsProvider-module--servicesModalWrapper--1EZw8";
export var customEnterModalAnimation = "modalsProvider-module--customEnterModalAnimation--2N5XY";
export var customLeaveModalAnimation = "modalsProvider-module--customLeaveModalAnimation--2MEDZ";